/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum TrickPlayType {
    NONE = 'NONE',
    REPLAY = 'REPLAY',
    RW = 'RW',
    PAUSE = 'PAUSE',
    PLAY = 'PLAY',
    FF = 'FF',
    ADVANCE = 'ADVANCE',
}
